import { useCallback } from "react";
import * as React from "react";

import Link from "@mui/material/Link";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import useStaffTasksV2 from "features/staff-tasks-v2/hooks/use-staff-tasks-v2.hook";
import { TaskNotification } from "services/types/notifications";

const TaskNotificationComponent = ({
  title,
  description,
  extra
}: TaskNotification) => {
  const { handleOpenTaskModal } = useStaffTasksV2();
  const { task, patient_id, id } = extra;
  const openTaskModalInViewMode = useCallback(() => {
    handleOpenTaskModal({ mode: "view", taskId: task || id });
  }, [handleOpenTaskModal, task, id]);

  return (
    <ListItemText
      primary={title}
      secondary={
        <Stack component="span" gap={0.5}>
          <Typography
            component="span"
            sx={{
              whiteSpace: "pre-line",
              cursor: "pointer",
              "&:hover": { color: "primary.main", textDecoration: "underline" }
            }}
            onClick={openTaskModalInViewMode}
          >
            {description}
          </Typography>
          {patient_id && task && (
            <Link
              href={`/patients/${patient_id}/tasks/?task_id=${task}&comment=${id}`}
              underline="hover"
              onClick={openTaskModalInViewMode}
              sx={{ cursor: "pointer" }}
            >
              View Comments
            </Link>
          )}
        </Stack>
      }
    />
  );
};

export default TaskNotificationComponent;
